<script setup>
import {inject, onMounted, ref} from "vue";
import PostContainer from "./components/PostContainer.vue";
import {ClientJS} from "clientjs";

const siteUrl = document.querySelector('meta[name="site-url"]').content;
const ids = inject('ids');
const userId = inject('userId');

const NUMBER = 3;

// 描画投稿データ
const posts = ref([]);

// ページを読み込む
const more = async () => {
  try {
    // 取得を試みる
    const response = await fetch(siteUrl+'place/get-posts?ids='+ids+'&sort=field&number=99999&fingerprint='+(new ClientJS()).getFingerprint());

    // JSON パースを試みる
    const data = await response.json();

    // 追加
    posts.value = posts.value.concat(data.data);
  }

    // 特に何もしない(例外で処理を中断するために存在)
  catch (e) {
    console.error(e);
  }
};

// データを読み込む
onMounted(() => {
  more();
});
</script>

<template>
  <div>
    <PostContainer
      v-for="post in posts"
      :key="post.id"
      container-type="list"
      :login-user-id="userId"
      :post="post"
    />
  </div>
</template>
